/* src/app/shared/popup-before-pay/popup-before-pay.component.scss */
.close {
  font-size: 14px !important;
  --padding-end: 10px;
}
.description {
  font-size: 14px;
}
.description p {
  font-size: 20px;
  text-align: center;
}
.closeDiv {
  flex-direction: row;
  box-sizing: border-box;
  display: flex;
  place-content: center flex-end;
  align-items: center;
  flex: 1 1 50px;
  max-height: 50px;
  min-height: 50px;
}
ion-button {
  z-index: 99;
}
h2 {
  margin: 0;
  color: var(--ion-color-primary);
  text-align: center;
  font-size: 35px;
  font-weight: 600;
}
.freeShippingAchievedDiv {
  border-radius: 15px;
  color: white;
  background: #1ca931;
  width: 80% !important;
  padding: 5px;
  animation: zoomIn ease-in-out 0.6s;
  margin: 15px auto;
}
.freeShippingAchievedDiv div {
  width: 98%;
}
@keyframes zoomIn {
  0% {
    transform: scale(1);
  }
  25% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}
.red-text {
  color: red;
  font-weight: bold;
}
.dialog-content div {
  width: 100%;
}
/*# sourceMappingURL=popup-before-pay.component-WCRQZXYR.css.map */
